export default __webpack_public_path__ + "static/17-ba5b06f876c4e61a99a08c3290ae1c15.png";